import { render } from "./DragAndDropImage.vue?vue&type=template&id=43f2483e"
import script from "./DragAndDropImage.vue?vue&type=script&lang=js"
export * from "./DragAndDropImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__